import { Navigate } from 'react-router-dom'
import { useFeatureFlagStore } from './useFeatureFlagStore'
import { useFeatureFlag } from './useFeatureFlag'

/**
 * Route-level gate driven by a feature flag.
 *
 * Renders nothing while the flag store is bootstrapping (avoids a
 * false-negative redirect before /api/flags resolves). Once loaded,
 * either renders `children` or redirects to `fallback`.
 */
export default function FlagGate({ flag, children, fallback = '/dashboard' }) {
  const loading = useFeatureFlagStore((s) => s.loading)
  const enabled = useFeatureFlag(flag)

  if (loading) return null
  if (!enabled) return <Navigate to={fallback} replace />
  return children
}
